// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2-WbC","savePackageButton":"ClientWallet_savePackageButton__1yOx2"};